import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import Goal from '../../models/Goal'

export interface GoalListState extends PaginatedApiState {
  goals?: Goal[]
}

const GoalList = (state: GoalListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<GoalListState>('GOAL_LIST')(state, action)
  }
}

export default GoalList
